import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box } from 'theme-ui';
import { EditorProvider, Theme, Sx, Styles } from '@theme-ui/editor';
import { TypeScale } from '@theme-ui/style-guide';
import { useReducer } from 'react';
import merge from 'lodash.merge';
import { EditorPackageDemo } from '../../components/editor-demo';
export const reducer = (state, next) => merge({}, state, next);
export const State = props => {
  const [value, setValue] = useReducer(reducer, props.value);
  return props.render([value, setValue]);
};
export const _frontmatter = {
  "title": "Editor"
};
const layoutProps = {
  reducer,
  State,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "theme-uieditor"
    }}>{`@theme-ui/editor`}</h1>
    <p>{`Components for editing Theme UI theme objects.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/editor
`}</code></pre>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <EditorPackageDemo mdxType="EditorPackageDemo" />
    <h2 {...{
      "id": "sx-style-object-editor"
    }}>{`Sx Style Object Editor`}</h2>
    <State value={{
      color: 'tomato',
      fontSize: 3
    }} render={([style, setStyle]) => <div>
      <pre children={JSON.stringify(style, null, 2)} />
      <Sx.Padding value={style} onChange={n => {
        console.log(style, n);
        setStyle(n);
      }} />
      <Sx.Colors value={style} onChange={setStyle} />
    </div>} mdxType="State" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      